import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/Card/Card.css';

export const prototypeName = 'ljPgbar03KCrqJ3G75QjcMV33ka8DdsekzGzeD8zs5Q71Gw52Li5GN8nLbQ';
export {styles};